export const PAGE_LIMIT = 20;
export const MESSAGE_TYPE_FILE = "FILE";
export const MESSAGE_FILE_TYPE_IMAGES = "Images";
/** Sendbird のグループチャンネル未命名時のデフォルト名 */
export const SEND_BIRD_DEFAULT_GROUP_CHANNEL_NAME = "Group Channel";

export const formatMessageHistoryDateTime = (createdAt: string): string => {
  return new Date(createdAt).toLocaleString("ja-JP", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
};
